<template>
    <svg
        :width="width"
        :height="height"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        :class="color"
    >
        <!-- THIN -->
        <g v-if="weight === 'THIN'" mask="url(#mask-thin)">
            <path
                d="M3.99996 19.9999V18.9999H20V19.9999H3.99996ZM5.32696 15.0769L2.23071 9.90364L3.68846 9.52289L6.35371 11.7961L10.4885 10.7171L5.56346 4.10564L7.42496 3.61914L14.5345 9.64414L18.8037 8.51339C19.1832 8.41472 19.5464 8.46756 19.8932 8.67189C20.24 8.87639 20.4628 9.16839 20.5615 9.54789C20.6601 9.92739 20.62 10.2906 20.4412 10.6374C20.2624 10.9842 19.9832 11.207 19.6037 11.3056L5.32696 15.0769Z"
                fill="currentColor"
            />
            <mask id="mask-thin" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                <rect width="24" height="24" fill="#D9D9D9" />
            </mask>
        </g>

        <!-- REGULAR -->
        <g v-else-if="weight === 'REGULAR'" mask="url(#mask-regular)">
            <path
                d="M3.49998 20.5001V19.0001H20.5V20.5001H3.49998ZM5.03848 15.5386L1.61548 9.82711L3.54423 9.31161L6.27698 11.6231L10.0942 10.6214L5.04423 3.86561L7.42498 3.23486L14.7172 9.38486L18.977 8.24436C19.4333 8.12003 19.8669 8.1777 20.2777 8.41736C20.6887 8.6572 20.9564 9.00528 21.0807 9.46161C21.2051 9.91811 21.1538 10.3518 20.927 10.7626C20.7 11.1734 20.3583 11.441 19.902 11.5654L5.03848 15.5386Z"
                fill="currentColor"
            />
            <mask id="mask-regular" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                <rect width="24" height="24" fill="#D9D9D9" />
            </mask>
        </g>

        <!-- FILL -->
        <g v-else mask="url(#mask-fill)">
            <path
                d="M3.49998 20.5001V19.0001H20.5V20.5001H3.49998ZM5.03848 15.5386L1.61548 9.82711L3.54423 9.31161L6.27698 11.6231L10.0942 10.6214L5.04423 3.86561L7.42498 3.23486L14.7172 9.38486L18.977 8.24436C19.4333 8.12003 19.8669 8.1777 20.2777 8.41736C20.6887 8.6572 20.9564 9.00528 21.0807 9.46161C21.2051 9.91811 21.1538 10.3518 20.927 10.7626C20.7 11.1734 20.3583 11.441 19.902 11.5654L5.03848 15.5386Z"
                fill="currentColor"
            />
            <mask id="mask-fill" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                <rect width="24" height="24" fill="#D9D9D9" />
            </mask>
        </g>
    </svg>
</template>

<script>
export default {
    name: 'flight-takeoff-icon',
    props: {
        width: {
            type: [String, Number],
            default: 24,
        },
        height: {
            type: [String, Number],
            default: 24,
        },
        color: {
            type: String,
            default: 'text-black',
        },
        weight: {
            type: String,
            default: 'THIN',
            validator: (val) => ['THIN', 'REGULAR', 'FILL'].includes(val),
        },
    },
};
</script>